import { render, staticRenderFns } from "./LegacyComment.vue?vue&type=template&id=8768c37a&"
import script from "./LegacyComment.vue?vue&type=script&lang=ts&"
export * from "./LegacyComment.vue?vue&type=script&lang=ts&"
import style0 from "./LegacyComment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports